<div class="w-full flex justify-content-end">
  <p-button icon="pi pi-refresh" (click)="load()" label="Refresh"></p-button>
</div>
<p-panel [showHeader]="false" styleClass="panel-shadow mt-3 no-padding-panel">
  <div class="ui-g order-import-container">
    <div class="ui-g-12">
      <div class="flex flex-wrap">
        <div *ngIf="orderImports && orderImports.length > 0" class="style2023 listbox-wrapper">
          <p-listbox
            styleClass="no-border-listbox mobile-listbox-block extended-xl-listbox-width"
            [ngModel]="selectedOrderImport"
            [options]="orderImports"
            (ngModelChange)="changeSelectedOrder($event)"
            dataKey="id"
          >
            <ng-template let-orderImport pTemplate="item">
              <div class="chip" style="display: inline-block">
                <span>{{ orderImport.value.status.name }}</span>
                <i
                  class="fa fa-info-circle ml-2"
                  aria-hidden="true"
                  [pTooltip]="orderImport.value.status.description"
                ></i>
              </div>
              <div class="chip ml-1" style="display: inline-block">
                <span>{{ orderImport.value.entriesCount }} Orders</span>
              </div>
              <div
                class="chip ml-1"
                style="display: inline-block"
                *ngIf="showSpinnerOnImportCard(orderImport.value)"
              >
                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
              </div>
              <div class="import-file-name mt-1">
                {{ orderImport.value.fileName }}
              </div>
              <div style="text-align: left; font-size: smaller" class="mt-1">
                {{ orderImport.value.createdOn | datex : 'ddd DD MMM HH:mm' }} by
                {{ orderImport.value.uploadedByUserFirstName }}
                {{ orderImport.value.uploadedByUserLastName }}
              </div>
            </ng-template>
          </p-listbox>
        </div>

        <div *ngIf="showEmptyView" class="empty-order-container">
          <i class="fa fa-upload" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem"></i>
          <h3>No Order Imports Available</h3>
          <p>There are currently no order imports to display. Upload a file to get started.</p>
        </div>

        <div
          *ngIf="orderImports && orderImports.length > 0 && !loadingImports"
          class="flex-grow-1"
          style="padding: 20px"
        >
          <div class="flex grid-gap-15 flex-wrap justify-content-start">
            <div class="flex-grow-1" style="flex-basis: 200px">
              <div class="import-order-action-header" *ngIf="selectedOrderImport">
                <div>
                  <h4>{{ selectedOrderImport.fileName }}</h4>
                </div>
                <div>
                  <button
                    pButton
                    type="button"
                    label="Delete Import"
                    (click)="removeImportDialog(selectedOrderImport)"
                    icon="pi pi-times"
                    class="ui-button-danger mt-1 mr-1"
                    [disabled]="!canDeleteImport(selectedOrderImport)"
                  ></button>
                  <button
                    pButton
                    type="button"
                    label="Validate Orders"
                    (click)="validateImport(selectedOrderImport.id)"
                    icon="pi pi-check"
                    class="ui-button-secondary mr-1 mt-1"
                    [disabled]="!canValidateImport(selectedOrderImport)"
                  ></button>
                  <button
                    pButton
                    type="button"
                    [disabled]="!canProcessOrderImport(selectedOrderImport)"
                    title="Process Order Import"
                    label="Import Orders"
                    (click)="transferOrder(selectedOrderImport)"
                    icon="fa fa-save"
                    class="mt-1 mr-1"
                  ></button>
                </div>
              </div>
              <p-table
                #importDetailsTable
                [value]="selectedOrderImport.orderImportDetails"
                styleClass="dynamic-size-table"
                [loading]="isLoading"
                *ngIf="selectedOrderImport"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th style="min-width: 200px">Order</th>
                    <th style="width: 50%">Warnings</th>
                    <th style="width: 50%">Errors</th>
                    <th style="min-width: 150px">Status</th>
                    <th style="min-width: 110px">Action</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item>
                  <tr [pSelectableRow]="item">
                    <td style="min-width: 200px">
                      <div class="vehicle-reg">
                        {{ item.vehicle_reg ? item.vehicle_reg : 'NO REG' }}
                      </div>
                      <div class="mt-2">{{ item.customer_order_number }}</div>
                    </td>
                    <td style="width: 50%">
                      <div *ngFor="let warning of parseValidationString(item.validation_warnings)">
                        <div>
                          <span class="font-bold" *ngFor="let name of warning.MemberNames"
                            >{{ name }}
                          </span>
                        </div>
                        <div>{{ warning.ErrorMessage }}</div>
                      </div>
                    </td>
                    <td style="width: 50%">
                      <div *ngIf="item.status_id != OrderImportStatus.TransferError">
                        <div *ngFor="let warning of parseValidationString(item.validation_errors)">
                          <div>
                            <span class="font-bold" *ngFor="let name of warning.MemberNames"
                              >{{ name }}
                            </span>
                          </div>
                          <div>{{ warning.ErrorMessage }}</div>
                        </div>
                      </div>
                      <div *ngIf="item.status_id == OrderImportStatus.TransferError">
                        {{ item.import_errors }}
                      </div>
                    </td>
                    <td style="min-width: 150px; text-align: center">
                      <div class="status-container">
                        <i
                          [ngClass]="getStatusIcon(item.status_id).icon"
                          [style.color]="getStatusIcon(item.status_id).color"
                          [pTooltip]="item.status_description"
                          class="status-icon"
                        ></i>
                        <span class="mt-1">{{ item.status }}</span>
                      </div>
                    </td>
                    <td style="min-width: 110px; text-align: center">
                      <div style="display: inline-block">
                        <button
                          pButton
                          type="button"
                          class="action-links"
                          (click)="editEntry(item)"
                          icon="fa fa-pencil"
                          [disabled]="!canEditRemoveImportLine(item, selectedOrderImport)"
                        ></button>
                        <button
                          pButton
                          type="button"
                          class="action-links ui-button-danger"
                          (click)="removeEntry(item)"
                          icon="fa fa-trash"
                          [disabled]="!canEditRemoveImportLine(item, selectedOrderImport)"
                        ></button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>

        <div class="empty-order-container" style="font-size: 25px" *ngIf="loadingImports">
          <i class="fa-15x fa fa-spin fa-spinner"></i>
        </div>
      </div>
    </div>
  </div>
</p-panel>

<p-confirmDialog icon="pi pi-exclamation-triangle" [style]="{ width: '425px' }" #cd>
  <p-footer>
    <button
      type="button"
      class="ui-button-secondary"
      pButton
      icon="pi pi-times"
      label="No"
      (click)="cd.reject()"
    ></button>
    <button
      type="button"
      class="ui-button-danger"
      pButton
      icon="pi pi-check"
      label="Yes"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>

<p-dialog
  header="Processing your request"
  [(visible)]="isBusy"
  [modal]="true"
  [responsive]="true"
  (onHide)="hideDialog()"
>
  <p-progressBar mode="indeterminate"></p-progressBar>
</p-dialog>

<p-dialog
  header="Processing your request"
  [(visible)]="isProcessing"
  [modal]="true"
  [responsive]="true"
  (onHide)="hideDialog()"
>
  <p-progressBar [value]="processingStatus"></p-progressBar>
</p-dialog>

<p-dialog
  header="Change Order Details"
  [(visible)]="showOrderUpdateDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '640px' }"
  styleClass="overflow-dialog"
  *ngIf="orderDetailsForm"
>
  <form
    [formGroup]="orderDetailsForm"
    (ngSubmit)="saveOrderDetails(orderDetailsForm.value)"
    ngClass="dialog-form ui-g-12"
  >
    <div class="ui-g" style="position: relative">
      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Customer Name</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="customer_name"
            ngClass="ui-g-12"
            pInputText
            formControlName="customer_name"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Order Type</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="order_type" ngClass="ui-g-12" pInputText formControlName="order_type" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Account Code</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="account_code" ngClass="ui-g-12" pInputText formControlName="account_code" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Is Vehicle Taxed</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="is_vehicle_taxed"
            ngClass="ui-g-12"
            pInputText
            formControlName="is_vehicle_taxed"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Is MOT Valid</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="is_mot_valid" ngClass="ui-g-12" pInputText formControlName="is_mot_valid" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Customer Order Number</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="customer_order_number"
            ngClass="ui-g-12"
            pInputText
            formControlName="customer_order_number"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>User Email Address</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="user_email_address"
            ngClass="ui-g-12"
            pInputText
            formControlName="user_email_address"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Vehicle Registration</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="vehicle_reg" ngClass="ui-g-12" pInputText formControlName="vehicle_reg" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>VIN</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="vin" ngClass="ui-g-12" pInputText formControlName="vin" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Make</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="make" ngClass="ui-g-12" pInputText formControlName="make" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Model</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="model" ngClass="ui-g-12" pInputText formControlName="model" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Kerb Weight</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="kerb_weight" ngClass="ui-g-12" pInputText formControlName="kerb_weight" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Fuel Type</label>
        </div>
        <div class="ui-grid-col-6">
          <input pInputText name="fuel_type" ngClass="ui-g-12" formControlName="fuel_type" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Site Name</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pickup_customer_site_name"
            ngClass="ui-g-12"
            pInputText
            formControlName="pickup_customer_site_name"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Business Name</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_business_name"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_business_name"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Address Line 1</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_address_line_1"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_address_line_1"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Address Line 2</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_address_line_1"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_address_line_2"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Address Line 3</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_address_line_3"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_address_line_3"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Town</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="pick_up_town" ngClass="ui-g-12" pInputText formControlName="pick_up_town" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Postcode</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_postcode"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_postcode"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Earliest</label>
        </div>
        <div class="ui-grid-col-6">
          <p-calendar
            [showTime]="true"
            formControlName="pick_up_earliest"
            dateFormat="dd/mm/yy"
            hourFormat="24"
          ></p-calendar>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Latest</label>
        </div>
        <div class="ui-grid-col-6">
          <p-calendar
            [showTime]="true"
            styleClass="full-width-calendar"
            dateFormat="dd/mm/yy"
            hourFormat="24"
            formControlName="pick_up_latest"
          ></p-calendar>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Additional Requirements</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_additional_requirements"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_additional_requirements"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Notes</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_latest"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_notes"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Forename</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_forename"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_forename"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Surname</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_surname"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_surname"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup E-mail</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_email"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_email"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Secondary E-mail</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_secondary_email"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_secondary_email"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Phone1</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_phone1"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_phone1"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Pickup Phone2</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="pick_up_phone2"
            ngClass="ui-g-12"
            pInputText
            formControlName="pick_up_phone2"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Drop Off Site Name</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_customer_site_name"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_customer_site_name"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Business Name</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_business_name"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_business_name"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Address Line 1</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_address_line_1"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_address_line_1"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Address Line 2</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_address_line_1"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_address_line_2"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Address Line 3</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_address_line_3"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_address_line_3"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Town</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_town"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_town"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Postcode</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_postcode"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_postcode"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Earliest</label>
        </div>
        <div class="ui-grid-col-6">
          <p-calendar
            [showTime]="true"
            dateFormat="dd/mm/yy"
            hourFormat="24"
            formControlName="drop_off_earliest"
          ></p-calendar>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Latest</label>
        </div>
        <div class="ui-grid-col-6">
          <p-calendar
            [showTime]="true"
            dateFormat="dd/mm/yy"
            hourFormat="24"
            formControlName="drop_off_latest"
          ></p-calendar>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Additional Requirements</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_additional_requirements"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_additional_requirements"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Notes</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_latest"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_notes"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Forename</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_forename"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_forename"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Surname</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_surname"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_surname"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff E-mail</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_email"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_email"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Secondary E-mail</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_secondary_email"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_secondary_email"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Phone1</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_phone1"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_phone1"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Dropoff Phone2</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="drop_off_phone2"
            ngClass="ui-g-12"
            pInputText
            formControlName="drop_off_phone2"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Held End Date</label>
        </div>
        <div class="ui-grid-col-6">
          <p-calendar
            [showTime]="true"
            dateFormat="dd/mm/yy"
            hourFormat="24"
            formControlName="hold_period"
          ></p-calendar>
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Purchase Order No.</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="purchase_order_no"
            ngClass="ui-g-12"
            pInputText
            maxlength="50"
            formControlName="purchase_order_no"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Department Code</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="department_code"
            ngClass="ui-g-12"
            pInputText
            formControlName="department_code"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Job Tagging</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="job_tagging" ngClass="ui-g-12" pInputText formControlName="job_tagging" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Department</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="department" ngClass="ui-g-12" pInputText formControlName="department" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Team</label>
        </div>
        <div class="ui-grid-col-6">
          <input name="team" ngClass="ui-g-12" pInputText formControlName="team" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Step Group Name</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="step_group_name"
            ngClass="ui-g-12"
            pInputText
            formControlName="step_group_name"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Enforce VRM Validation</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="enforce_vrm_validation"
            ngClass="ui-g-12"
            pInputText
            formControlName="enforce_vrm_validation"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Customer Service Fees</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            name="customer_service_fees"
            ngClass="ui-g-12"
            pInputText
            formControlName="customer_service_fees"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>MoDel Pin</label>
        </div>
        <div class="ui-grid-col-6">
          <input pInputText name="moDel_pin" ngClass="ui-g-12" formControlName="moDel_pin" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Release Code</label>
        </div>
        <div class="ui-grid-col-6">
          <input pInputText name="release_code" ngClass="ui-g-12" formControlName="release_code" />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Combine Group Code</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            pInputText
            name="combine_group_code"
            ngClass="ui-g-12"
            formControlName="combine_group_code"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>What3Words Pickup Address</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            pInputText
            name="what_3_words_pick_up_address"
            ngClass="ui-g-12"
            formControlName="what_3_words_pick_up_address"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>What3Words DropOff Address</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            pInputText
            name="what_3_words_drop_off_address"
            ngClass="ui-g-12"
            formControlName="what_3_words_drop_off_address"
          />
        </div>
      </div>

      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Supplier</label>
        </div>
        <div class="ui-grid-col-6">
          <input pInputText name="supplier" ngClass="ui-g-12" formControlName="supplier" />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Fixed Price</label>
        </div>
        <div class="ui-grid-col-6">
          <input pInputText name="fixed_price" ngClass="ui-g-12" formControlName="fixed_price" />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-grid-col-6">
          <label>Task Sequence</label>
        </div>
        <div class="ui-grid-col-6">
          <input
            pInputText
            name="task_sequence"
            ngClass="ui-g-12"
            formControlName="task_sequence"
          />
        </div>
      </div>
    </div>
  </form>
  <p-footer>
    <button
      type="button"
      (click)="showOrderUpdateDialog = false"
      pButton
      icon="fa ui-icon-close"
      label="Cancel"
      class="ui-button btn-to-right"
    ></button>
    <button
      pButton
      icon="fa ui-icon-check"
      label="Save"
      class="ui-button green-btn btn-to-right"
      (click)="saveOrderDetails(orderDetailsForm.value)"
    ></button>
  </p-footer>
</p-dialog>
